export function findFieldDeep(obj, fieldNames) {
  if (!obj || typeof obj !== 'object') return null;
  const fields = Array.isArray(fieldNames) ? fieldNames : [fieldNames];

  for (const key of fields) {
    if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key]) {
      return obj[key];
    }
  }

  for (const value of Object.values(obj)) {
    if (value && typeof value === 'object') {
      const result = findFieldDeep(value, fields);
      if (result) return result;
    }
  }

  return null;
}

export function getAdminLembagaScope(admin) {
  const id = String(
    findFieldDeep(admin, ['selected_id_lembaga', 'id_lembaga', 'idLembaga']) || ''
  ).trim();
  const name = String(
    findFieldDeep(admin, ['selected_nama_lembaga', 'nama_lembaga', 'namaLembaga']) || ''
  ).trim();

  return {
    id,
    name,
    active: Boolean(id),
  };
}

export function normalizeScopeValue(value) {
  return String(value ?? '').trim().toLowerCase();
}

export function buildAdminMitraUserScope(records) {
  const kodeUsers = new Set();
  const idUsers = new Set();

  for (const record of Array.isArray(records) ? records : []) {
    const kodeUserCandidates = [
      findFieldDeep(record, ['kode_user', 'kodeUser']),
      findFieldDeep(record?.user, ['kode_user', 'kodeUser']),
      findFieldDeep(record?.users, ['kode_user', 'kodeUser']),
    ];
    const idUserCandidates = [
      findFieldDeep(record, ['id_user', 'idUser']),
      findFieldDeep(record?.user, ['id_user', 'idUser', 'id']),
      findFieldDeep(record?.users, ['id_user', 'idUser', 'id']),
    ];

    kodeUserCandidates.forEach((value) => {
      const normalized = String(value || '').trim();
      if (normalized) kodeUsers.add(normalized);
    });

    idUserCandidates.forEach((value) => {
      const normalized = String(value || '').trim();
      if (normalized) idUsers.add(normalized);
    });
  }

  return { kodeUsers, idUsers };
}

export function matchItemToAdminScope(item, scope, adminMitraScope = null) {
  if (!scope?.active) return true;

  const lembagaIds = [
    findFieldDeep(item, ['id_lembaga', 'idLembaga']),
    findFieldDeep(item?.lembaga, ['id_lembaga', 'idLembaga', 'id']),
    findFieldDeep(item?.user, ['id_lembaga', 'idLembaga']),
  ]
    .map((value) => String(value || '').trim())
    .filter(Boolean);

  if (lembagaIds.some((value) => value === scope.id)) {
    return true;
  }

  const lembagaNames = [
    findFieldDeep(item, ['nama_lembaga', 'namaLembaga']),
    findFieldDeep(item?.lembaga, ['nama_lembaga', 'namaLembaga', 'nama']),
  ]
    .map(normalizeScopeValue)
    .filter(Boolean);

  if (scope.name && lembagaNames.some((value) => value === normalizeScopeValue(scope.name))) {
    return true;
  }

  const kodeUser = String(findFieldDeep(item, ['kode_user', 'kodeUser']) || '').trim();
  const idUser = String(findFieldDeep(item, ['id_user', 'idUser']) || '').trim();

  if (adminMitraScope?.kodeUsers?.size && kodeUser && adminMitraScope.kodeUsers.has(kodeUser)) {
    return true;
  }

  if (adminMitraScope?.idUsers?.size && idUser && adminMitraScope.idUsers.has(idUser)) {
    return true;
  }

  return false;
}

export function extractArrayPayload(payload, preferredKeys = []) {
  if (Array.isArray(payload)) return payload;

  for (const key of preferredKeys) {
    if (Array.isArray(payload?.[key])) return payload[key];
  }

  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.result)) return payload.result;

  return [];
}
